import React from 'react';
import { Calculator, TrendingUp, Users, FileText } from 'lucide-react';

export default function Features() {
  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Pourquoi nous faire confiance ?
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-700 lg:mx-auto">
            Des outils performants et une expertise reconnue pour vous accompagner dans votre projet immobilier.
          </p>
        </div>

        <div className="mt-10">
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                icon: Calculator,
                title: 'Estimation précise',
                description: 'Algorithmes sophistiqués basés sur les dernières transactions'
              },
              {
                icon: TrendingUp,
                title: 'Données du marché',
                description: 'Accès aux prix du marché en temps réel'
              },
              {
                icon: Users,
                title: 'Réseau d\'experts',
                description: 'Des professionnels qualifiés à votre service'
              },
              {
                icon: FileText,
                title: 'Rapport détaillé',
                description: 'Analyse complète de votre bien immobilier'
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-xl p-8 shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                  transform hover:scale-[1.02] transition-all duration-300
                  relative overflow-hidden rounded-xl"
              >
                <div className="relative z-10">
                  <div className="h-12 w-12 bg-gradient-to-br from-[#2A4365] via-[#4A5568] to-[#C4A052] rounded-xl flex items-center justify-center mb-6">
                    <feature.icon className="h-6 w-6 text-white" strokeWidth={2.5} />
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {feature.title}
                  </h3>

                  <p className="text-gray-700">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}